import config from 'configAlias';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isPlainObject from 'lodash/isPlainObject';
import keys from 'lodash/keys';
import omit from 'lodash/omit';
import marketReducers from 'marketComponentsAlias/state/reducers';
import { combineReducers } from 'redux-loop';
import {
  checkFeatureFlag,
  parseFeatureFlagsConfig,
} from 'srcAlias/utils/featureFlag';
import buildNavigationInitialState from '../utils/buildNavigationInitialState';
import buildSegmentInitialState from '../utils/buildSegmentInitialState';
import createApplicationReducer from './applicationReducer';
import divaReducer from './divaReducer';
import createInteractionHistoryReducer from './interactionHistoryReducer';
import createNavigationReducer from './navigationReducer';
import createSegmentStateReducer from './segmentStateReducer';

export const parseSegmentsConfig = segments =>
  segments.reduce((acc, segment) => {
    if (isArray(segment)) {
      const [segmentName, segmentConfig = {}] = segment;

      if (segmentConfig.flag) {
        const flag = segmentConfig.flag || {};

        if (!checkFeatureFlag(flag)) {
          return acc;
        }
      }

      const { pages } = segmentConfig;
      const pagesExist = isArray(pages) && pages.length > 0;

      const pagesConfig = pagesExist
        ? pages.reduce((acc, page) => {
            if (isPlainObject(page)) {
              const { flag, ...pageConfig } = page;

              if (flag && !checkFeatureFlag(flag)) {
                return acc;
              }

              return [...acc, pageConfig];
            }

            return [...acc, page];
          }, [])
        : [];

      return {
        ...acc,
        ...(pagesConfig.length > 0 || !pagesExist
          ? {
              [segmentName]: {
                ...omit(segmentConfig, ['flag']),
                ...(pagesConfig.length > 0
                  ? {
                      pages: pagesConfig,
                    }
                  : {}),
                pagesConfig: {
                  config: { exclude: true },
                },
                readOnlyReviewSections: [],
              },
            }
          : {}),
      };
    }

    return { ...acc, [segment]: {} };
  }, {});

export default (initialState = {}) => {
  const divaConfig = config.diva;
  const featureFlagsConfig = parseFeatureFlagsConfig(config.featureFlags);
  const segmentsConfig = parseSegmentsConfig(config.segments);
  const segmentNames = keys(segmentsConfig);

  return combineReducers({
    appState: () => featureFlagsConfig,
    sessionId: (state = initialState.sessionId || null) => state,
    queryParams: (state = initialState.queryParams || {}) => state,
    navigation: createNavigationReducer(
      segmentsConfig,
      segmentNames,
      buildNavigationInitialState(initialState.navigation)
    ),
    interactionHistory: createInteractionHistoryReducer(
      initialState.interactionHistory
    ),
    productCodes: (state = initialState.productCodes || {}) => state,
    diva: divaReducer(divaConfig, featureFlagsConfig),
    segmentsConfig: () => segmentsConfig,
    segmentState: createSegmentStateReducer(
      segmentNames,
      buildSegmentInitialState(initialState.segmentState)
    ),
    application: createApplicationReducer(initialState.application),
    identityVerified: (state = initialState.identityVerified || false) => state,
    ...(isFunction(marketReducers)
      ? marketReducers(
          {
            ...config,
            featureFlags: featureFlagsConfig,
            segments: segmentsConfig,
          },
          initialState
        )
      : {}),
  });
};
